/* eslint-disable */
import {Survey, UpdateSurveyIF, AddSurveyIF} from "../../models/survey";
import SurveyEvents from "../events/SurveyEvents";

// アンケート情報取得開始
export const GetSurveyById = (userId: number, videoId: number) => ({
    type: SurveyEvents.LoadSurveyByIdStarted,
    userId,
    videoId
} as const);

// アンケート情報取得完了
export const GetSurveyByIdComplete = (surveys: Survey[]) => ({
    type: SurveyEvents.LoadSurveyByIdComplete,
    surveys
} as const);

// アンケート回答登録開始
export const AddSurveyAnswer = (userId: number, videoId: number, surveyId: number, questionId: number, choiceId: number[]) => ({
    type: SurveyEvents.AddSurveyAnswerStarted,
    userId, videoId, surveyId, questionId, choiceId
} as const);

// アンケート回答登録完了
export const AddSurveyAnswerComplete = (surveys: Survey[]) => ({
    type: SurveyEvents.AddSurveyAnswerComplete,
    surveys
} as const);

// アンケート回答登録失敗
export const AddSurveyAnswerFailed = (error: string) => ({
    type: SurveyEvents.AddSurveyAnswerFailed,
    error
} as const);
// 全アンケート情報取得開始
export const GetAllSurvey = () => ({
    type: SurveyEvents.GetAllSurveyStarted,
} as const);

// 全アンケート情報取得完了
export const GetAllSurveyComplete = (allSurvey: Survey[]) => ({
    type: SurveyEvents.GetAllSurveyComplete,
    allSurvey
} as const);

// アンケート新規追加開始
export const AddSurvey = (newSurvey: AddSurveyIF) => ({
    type: SurveyEvents.AddSurveyStarted,
    newSurvey
} as const);

// アンケート新規追加完了
export const AddSurveyComplete = (newSurvey: Survey) => ({
    type: SurveyEvents.AddSurveyComplete,
    newSurvey
} as const);

// アンケート更新開始
export const UpdateSurvey = (updateSurvey: UpdateSurveyIF) => ({
    type: SurveyEvents.UpdateSurveyStarted,
    updateSurvey
} as const);

// アンケート更新完了
export const UpdateSurveyComplete = (surveys: Survey[]) => ({
    type: SurveyEvents.UpdateSurveyComplete,
    surveys
} as const);

// アンケート更新失敗
export const UpdateSurveyFailed = () => ({
    type: SurveyEvents.UpdateSurveyFailed
} as const);
